import { Group, Image, List, ListItem, Stack, Text, Title } from '@mantine/core'
import { TwContainer } from '@/lib/components/TwContainer'

export const StiSectionFour = () => {
	return (
		<section>
			<TwContainer className={'justify-center py-20  gap-12'} column>
				<Group gap={0} justify={'space-around'}>
					<Stack className={'max-w-xl p-8'} gap={'xs'}>
						<Title variant={'title2'}>STI and STD Information</Title>
						<Text variant={'gray'} ta={'left'}>
							Knowledge is power when it comes to sexual health. On our website, you'll find a wealth of information about STIs and STDs,
						</Text>
						<Title my={'md'} ta={'left'} fz={18}>
							including:
						</Title>
						<List spacing={'lg'}>
							<ListItem>
								<strong>Types of STIs and STDs:</strong> Learn about the various sexually transmitted infections, their symptoms, and how they can be
								transmitted.
							</ListItem>
							<ListItem>
								<strong>Prevention and Safe Practices:</strong> Discover essential information about safe sex practices, the use of condoms, and how
								to reduce your risk of contracting or spreading STIs and STDs.
							</ListItem>
							<ListItem>
								<strong>Testing and Early Detection:</strong> Understand the importance of regular testing, the testing process, and how early
								detection can make a difference in your health.
							</ListItem>
						</List>
					</Stack>
					<Image
						loading={'lazy'}
						className={'md:max-w-sm max-w-xs rounded-[32px]'}
						src={'/images/img_37.webp'}
						w={380}
						h={380}
						alt={'What is PrEP?'}
					/>
				</Group>
			</TwContainer>
		</section>
	)
}
